<button (click)="onClicked($event)" [disabled]="loading || disabled" mat-icon-button color="{{color}}" class="icu-cursor-pointer">
  <ng-container *ngIf="!useProgressBar; else progressBar">
    <mat-icon *ngIf="icon" [ngClass]="{'rotate': rotating}" class="icu-refresh-icon icu-w-h-auto">{{icon}}</mat-icon>
  </ng-container>
  <ng-template #progressBar style="display: block;">
    <mat-icon *ngIf="!loading" class="icu-refresh-icon icu-w-h-auto">{{icon}}</mat-icon>
    <mat-progress-bar *ngIf="loading" mode="indeterminate" color="{{color}}"></mat-progress-bar>
  </ng-template>
</button>